const languagesList = [
  { value: 'aa', suffix: 'Afar', name: 'AA' },
  { value: 'ab', suffix: 'Abkhazian', name: 'AB' },
  { value: 'ae', suffix: 'Avestan', name: 'AE' },
  { value: 'af', suffix: 'Afrikaans', name: 'AF' },
  { value: 'ak', suffix: 'Akan', name: 'AK' },
  { value: 'am', suffix: 'Amharic', name: 'AM' },
  { value: 'an', suffix: 'Aragonese', name: 'AN' },
  { value: 'ar', suffix: 'Arabic', name: 'AR' },
  { value: 'as', suffix: 'Assamese', name: 'AS' },
  { value: 'av', suffix: 'Avaric', name: 'AV' },
  { value: 'ay', suffix: 'Aymara', name: 'AY' },
  { value: 'az', suffix: 'Azerbaijani', name: 'AZ' },
  { value: 'ba', suffix: 'Bashkir', name: 'BA' },
  { value: 'be', suffix: 'Belarusian', name: 'BE' },
  { value: 'bg', suffix: 'Bulgarian', name: 'BG' },
  { value: 'bh', suffix: 'Bihari languages', name: 'BH' },
  { value: 'bi', suffix: 'Bislama', name: 'BI' },
  { value: 'bm', suffix: 'Bambara', name: 'BM' },
  { value: 'bn', suffix: 'Bengali', name: 'BN' },
  { value: 'bo', suffix: 'Tibetan', name: 'BO' },
  { value: 'br', suffix: 'Breton', name: 'BR' },
  { value: 'bs', suffix: 'Bosnian', name: 'BS' },
  { value: 'ca', suffix: 'Catalan; Valencian', name: 'CA' },
  { value: 'ce', suffix: 'Chechen', name: 'CE' },
  { value: 'ch', suffix: 'Chamorro', name: 'CH' },
  { value: 'co', suffix: 'Corsican', name: 'CO' },
  { value: 'cr', suffix: 'Cree', name: 'CR' },
  { value: 'cs', suffix: 'Czech', name: 'CS' },
  {
    value: 'cu',
    suffix:
      'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic',
    name: 'CU',
  },
  { value: 'cv', suffix: 'Chuvash', name: 'CV' },
  { value: 'cy', suffix: 'Welsh', name: 'CY' },
  { value: 'da', suffix: 'Danish', name: 'DA' },
  { value: 'de', suffix: 'German', name: 'DE' },
  { value: 'dv', suffix: 'Divehi; Dhivehi; Maldivian', name: 'DV' },
  { value: 'dz', suffix: 'Dzongkha', name: 'DZ' },
  { value: 'ee', suffix: 'Ewe', name: 'EE' },
  { value: 'el', suffix: 'Greek, Modern (1453-)', name: 'EL' },
  { value: 'en', suffix: 'English', name: 'EN' },
  { value: 'eo', suffix: 'Esperanto', name: 'EO' },
  { value: 'es', suffix: 'Spanish; Castilian', name: 'ES' },
  { value: 'et', suffix: 'Estonian', name: 'ET' },
  { value: 'eu', suffix: 'Basque', name: 'EU' },
  { value: 'fa', suffix: 'Persian', name: 'FA' },
  { value: 'ff', suffix: 'Fulah', name: 'FF' },
  { value: 'fi', suffix: 'Finnish', name: 'FI' },
  { value: 'fj', suffix: 'Fijian', name: 'FJ' },
  { value: 'fo', suffix: 'Faroese', name: 'FO' },
  { value: 'fr', suffix: 'French', name: 'FR' },
  { value: 'fy', suffix: 'Western Frisian', name: 'FY' },
  { value: 'ga', suffix: 'Irish', name: 'GA' },
  { value: 'gd', suffix: 'Gaelic; Scomttish Gaelic', name: 'GD' },
  { value: 'gl', suffix: 'Galician', name: 'GL' },
  { value: 'gn', suffix: 'Guarani', name: 'GN' },
  { value: 'gu', suffix: 'Gujarati', name: 'GU' },
  { value: 'gv', suffix: 'Manx', name: 'GV' },
  { value: 'ha', suffix: 'Hausa', name: 'HA' },
  { value: 'he', suffix: 'Hebrew', name: 'HE' },
  { value: 'hi', suffix: 'Hindi', name: 'HI' },
  { value: 'ho', suffix: 'Hiri Motu', name: 'HO' },
  { value: 'hr', suffix: 'Croatian', name: 'HR' },
  { value: 'ht', suffix: 'Haitian; Haitian Creole', name: 'HT' },
  { value: 'hu', suffix: 'Hungarian', name: 'HU' },
  { value: 'hy', suffix: 'Armenian', name: 'HY' },
  { value: 'hz', suffix: 'Herero', name: 'HZ' },
  {
    value: 'ia',
    suffix: 'Interlingua (International Auxiliary Language Association)',
    name: 'IA',
  },
  { value: 'id', suffix: 'Indonesian', name: 'ID' },
  { value: 'ie', suffix: 'Interlingue; Occidental', name: 'IE' },
  { value: 'ig', suffix: 'Igbo', name: 'IG' },
  { value: 'ii', suffix: 'Sichuan Yi; Nuosu', name: 'II' },
  { value: 'ik', suffix: 'Inupiaq', name: 'IK' },
  { value: 'io', suffix: 'Ido', name: 'IO' },
  { value: 'is', suffix: 'Icelandic', name: 'IS' },
  { value: 'it', suffix: 'Italian', name: 'IT' },
  { value: 'iu', suffix: 'Inuktitut', name: 'IU' },
  { value: 'ja', suffix: 'Japanese', name: 'JA' },
  { value: 'jv', suffix: 'Javanese', name: 'JV' },
  { value: 'ka', suffix: 'Georgian', name: 'KA' },
  { value: 'kg', suffix: 'Kongo', name: 'KG' },
  { value: 'ki', suffix: 'Kikuyu; Gikuyu', name: 'KI' },
  { value: 'kj', suffix: 'Kuanyama; Kwanyama', name: 'KJ' },
  { value: 'kk', suffix: 'Kazakh', name: 'KK' },
  { value: 'kl', suffix: 'Kalaallisut; Greenlandic', name: 'KL' },
  { value: 'km', suffix: 'Central Khmer', name: 'KM' },
  { value: 'kn', suffix: 'Kannada', name: 'KN' },
  { value: 'ko', suffix: 'Korean', name: 'KO' },
  { value: 'kr', suffix: 'Kanuri', name: 'KR' },
  { value: 'ks', suffix: 'Kashmiri', name: 'KS' },
  { value: 'ku', suffix: 'Kurdish', name: 'KU' },
  { value: 'kv', suffix: 'Komi', name: 'KV' },
  { value: 'kw', suffix: 'Cornish', name: 'KW' },
  { value: 'ky', suffix: 'Kirghiz; Kyrgyz', name: 'KY' },
  { value: 'la', suffix: 'Latin', name: 'LA' },
  { value: 'lb', suffix: 'Luxembourgish; Letzeburgesch', name: 'LB' },
  { value: 'lg', suffix: 'Ganda', name: 'LG' },
  { value: 'li', suffix: 'Limburgan; Limburger; Limburgish', name: 'LI' },
  { value: 'ln', suffix: 'Lingala', name: 'LN' },
  { value: 'lo', suffix: 'Lao', name: 'LO' },
  { value: 'lt', suffix: 'Lithuanian', name: 'LT' },
  { value: 'lu', suffix: 'Luba-Katanga', name: 'LU' },
  { value: 'lv', suffix: 'Latvian', name: 'LV' },
  { value: 'mg', suffix: 'Malagasy', name: 'MG' },
  { value: 'mh', suffix: 'Marshallese', name: 'MH' },
  { value: 'mi', suffix: 'Maori', name: 'MI' },
  { value: 'mk', suffix: 'Macedonian', name: 'MK' },
  { value: 'ml', suffix: 'Malayalam', name: 'ML' },
  { value: 'mn', suffix: 'Mongolian', name: 'MN' },
  { value: 'mr', suffix: 'Marathi', name: 'MR' },
  { value: 'ms', suffix: 'Malay', name: 'MS' },
  { value: 'mt', suffix: 'Maltese', name: 'MT' },
  { value: 'my', suffix: 'Burmese', name: 'MY' },
  { value: 'na', suffix: 'Nauru', name: 'NA' },
  { value: 'nb', suffix: 'Bokmål, Norwegian; Norwegian Bokmål', name: 'NB' },
  { value: 'nd', suffix: 'Ndebele, North; North Ndebele', name: 'ND' },
  { value: 'ne', suffix: 'Nepali', name: 'NE' },
  { value: 'ng', suffix: 'Ndonga', name: 'NG' },
  { value: 'nl', suffix: 'Dutch; Flemish', name: 'NL' },
  { value: 'nn', suffix: 'Norwegian Nynorsk; Nynorsk, Norwegian', name: 'NN' },
  { value: 'no', suffix: 'Norwegian', name: 'NO' },
  { value: 'nr', suffix: 'Ndebele, South; South Ndebele', name: 'NR' },
  { value: 'nv', suffix: 'Navajo; Navaho', name: 'NV' },
  { value: 'ny', suffix: 'Chichewa; Chewa; Nyanja', name: 'NY' },
  { value: 'oc', suffix: 'Occitan (post 1500)', name: 'OC' },
  { value: 'oj', suffix: 'Ojibwa', name: 'OJ' },
  { value: 'om', suffix: 'Oromo', name: 'OM' },
  { value: 'or', suffix: 'Oriya', name: 'OR' },
  { value: 'os', suffix: 'Ossetian; Ossetic', name: 'OS' },
  { value: 'pa', suffix: 'Panjabi; Punjabi', name: 'PA' },
  { value: 'pi', suffix: 'Pali', name: 'PI' },
  { value: 'pl', suffix: 'Polish', name: 'PL' },
  { value: 'ps', suffix: 'Pushto; Pashto', name: 'PS' },
  { value: 'pt', suffix: 'Portuguese', name: 'PT' },
  { value: 'qu', suffix: 'Quechua', name: 'QU' },
  { value: 'rm', suffix: 'Romansh', name: 'RM' },
  { value: 'rn', suffix: 'Rundi', name: 'RN' },
  { value: 'ro', suffix: 'Romanian; Moldavian; Moldovan', name: 'RO' },
  { value: 'ru', suffix: 'Russian', name: 'RU' },
  { value: 'rw', suffix: 'Kinyarwanda', name: 'RW' },
  { value: 'sa', suffix: 'Sanskrit', name: 'SA' },
  { value: 'sc', suffix: 'Sardinian', name: 'SC' },
  { value: 'sd', suffix: 'Sindhi', name: 'SD' },
  { value: 'se', suffix: 'Northern Sami', name: 'SE' },
  { value: 'sg', suffix: 'Sango', name: 'SG' },
  { value: 'si', suffix: 'Sinhala; Sinhalese', name: 'SI' },
  { value: 'sk', suffix: 'Slovak', name: 'SK' },
  { value: 'sl', suffix: 'Slovenian', name: 'SL' },
  { value: 'sm', suffix: 'Samoan', name: 'SM' },
  { value: 'sn', suffix: 'Shona', name: 'SN' },
  { value: 'so', suffix: 'Somali', name: 'SO' },
  { value: 'sq', suffix: 'Albanian', name: 'SQ' },
  { value: 'sr', suffix: 'Serbian', name: 'SR' },
  { value: 'ss', suffix: 'Swati', name: 'SS' },
  { value: 'st', suffix: 'Sotho, Southern', name: 'ST' },
  { value: 'su', suffix: 'Sundanese', name: 'SU' },
  { value: 'sv', suffix: 'Swedish', name: 'SV' },
  { value: 'sw', suffix: 'Swahili', name: 'SW' },
  { value: 'ta', suffix: 'Tamil', name: 'TA' },
  { value: 'te', suffix: 'Telugu', name: 'TE' },
  { value: 'tg', suffix: 'Tajik', name: 'TG' },
  { value: 'th', suffix: 'Thai', name: 'TH' },
  { value: 'ti', suffix: 'Tigrinya', name: 'TI' },
  { value: 'tk', suffix: 'Turkmen', name: 'TK' },
  { value: 'tl', suffix: 'Tagalog', name: 'TL' },
  { value: 'tn', suffix: 'Tswana', name: 'TN' },
  { value: 'to', suffix: 'Tonga (Tonga Islands)', name: 'TO' },
  { value: 'tr', suffix: 'Turkish', name: 'TR' },
  { value: 'ts', suffix: 'Tsonga', name: 'TS' },
  { value: 'tt', suffix: 'Tatar', name: 'TT' },
  { value: 'tw', suffix: 'Twi', name: 'TW' },
  { value: 'ty', suffix: 'Tahitian', name: 'TY' },
  { value: 'ug', suffix: 'Uighur; Uyghur', name: 'UG' },
  { value: 'uk', suffix: 'Ukrainian', name: 'UK' },
  { value: 'ur', suffix: 'Urdu', name: 'UR' },
  { value: 'uz', suffix: 'Uzbek', name: 'UZ' },
  { value: 've', suffix: 'Venda', name: 'VE' },
  { value: 'vi', suffix: 'Vietnamese', name: 'VI' },
  { value: 'vo', suffix: 'Volapük', name: 'VO' },
  { value: 'wa', suffix: 'Walloon', name: 'WA' },
  { value: 'wo', suffix: 'Wolof', name: 'WO' },
  { value: 'xh', suffix: 'Xhosa', name: 'XH' },
  { value: 'yi', suffix: 'Yiddish', name: 'YI' },
  { value: 'yo', suffix: 'Yoruba', name: 'YO' },
  { value: 'za', suffix: 'Zhuang; Chuang', name: 'ZA' },
  { value: 'zh', suffix: 'Chinese', name: 'ZH' },
  { value: 'zu', suffix: 'Zulu', name: 'ZU' },
];

export default languagesList;
